function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "g17",
  transform: "matrix(2.6805433,0,0,3.1184498,-498.19015,-538.67073)"
}, React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 10,
  x1: 342.39999,
  x2: 342.39999,
  y1: 213.39999,
  y2: 267.89999,
  id: "line9"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 10,
  x1: 369.60001,
  x2: 315.20001,
  y1: 240.60001,
  y2: 240.60001,
  id: "line11"
}), React.createElement("circle", {
  cx: 256,
  cy: 213.39999,
  fill: "none",
  r: 34.5,
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 10,
  id: "circle13"
}), React.createElement("path", {
  d: "m 318.4,331.7 c 0,-34.5 -27.9,-62.4 -62.4,-62.4 -34.5,0 -62.4,27.9 -62.4,62.4 z",
  fill: "none",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 10,
  id: "path15"
}));

var SvgShareV2 = function SvgShareV2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: "512px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShareV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share-v2.2f458f8e.svg";
export { ForwardRef as ReactComponent };